import type { ComponentProps, ReactNode } from 'react';

import { cn } from '@/lib/utils';

/**
 * The page's horizontal frame. Thirteen blocks were carrying a verbatim copy
 * of this class string, which is how the gutters drifted apart last time.
 *
 * `max-w-[1400px]` is a deliberate deviation from the mockup, which has no max
 * width and runs to 2560px on a wide monitor.
 */
export function Section({
    children,
    className,
    ...props
}: ComponentProps<'section'> & { children: ReactNode }) {
    return (
        <section
            {...props}
            className={cn(
                'relative z-[1] mx-auto w-full max-w-[1400px] scroll-mt-[72px] px-[clamp(20px,5vw,72px)] py-[clamp(56px,9vw,88px)]',
                className,
            )}
        >
            {children}
        </section>
    );
}
